module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M31 0h-9c-1.106 0-1.368.632-.586 1.414l3.172 3.172-6.294 6.292a1 1 0 0 0 0 1.414l1.414 1.414a1 1 0 0 0 1.414 0l6.292-6.292 3.172 3.172c.784.782 1.416.52 1.416-.586V1a1 1 0 0 0-1-1zM12.29 18.292a1 1 0 0 0-1.414 0l-6.292 6.292-3.17-3.172C.63 20.632 0 20.894 0 22v9c0 .552.446 1 .996 1h9c1.106 0 1.368-.632.586-1.414L7.41 27.414l6.292-6.292a1 1 0 0 0 0-1.414l-1.412-1.416z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/maximize-4.js
// module id = 1265
// module chunks = 14